import { client, errorValidation } from "./service";

export const getAgents = async function () {
    try {
        let response = await client.get(`/agents/list`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data, error: null };
    } catch (e) {
        return { data: null, ...errorValidation(e) }
    }
}

export const getAgent = async function (id) {
    try {
        let response = await client.get(`/agents/detail/${id}`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data, error: null };
    } catch (e) {
        return { data: null, ...errorValidation(e) }
    }
}